import { useDashboardAPI } from '../../../../../hooks';
import { WidgetType } from '../../../widget.types';
export const useDeviationsAPI = (widgetType) => {
    const api = useDashboardAPI();
    switch (widgetType) {
        case WidgetType.DELIVER_DEVIATION:
            return api.deliveries;
        case WidgetType.LOAD_DEVIATION:
            return api.loads;
        default:
            throw new Error(`Unknown widget type: ${widgetType}`);
    }
};
//# sourceMappingURL=useDeviationsAPI.js.map